import { useMemo, useState } from "@lukekaalim/act"

/**
 * A simple incrementing state hook. Causes a render update, and provides
 * an incrementing key value to bust deps with.
 * @returns 
 */
export const useRefresh = () => {
  const [key, setKey] = useState(0);

  const refresh = useMemo(() => () => {
    setKey(k => k + 1)
  }, []);

  return useMemo(() => {
    return [refresh, key] as const;
  }, [key])
}